// src/theme/tokens.ts

export const colors = {
  primary: {
    900: '#002130',
    800: '#00425F',
    700: '#005D86',
    600: '#0072A4',
    500: '#007EB6', // Brand color
    400: '#009ADE',
    300: '#50C9FF',
    200: '#A6E3FF',
    100: '#D9F4FF',
    50: '#EAF9FF',
  },

  secondary: {
    900: '#00141C',
    800: '#002738',
    700: '#003146',
    600: '#003B54',
    500: '#004E70', // Brand color
    400: '#196EBC',
    300: '#5E90A8',
    200: '#94B4C4',
    100: '#E3EAFF',
    50: '#F2F7FA',
  },

  error: {
    900: '#2D0000',
    800: '#5A0000',
    700: '#790001',
    600: '#A60001',
    500: '#D93A52',
    400: '#DE566B',
    300: '#E37283',
    200: '#EAABB5',
    100: '#F4C7CE',
    50: '#FDE7EA',
  },

  warning: {
    900: '#261701',
    800: '#4C2E02',
    700: '#804F02',
    600: '#BD7304',
    500: '#E38A05',
    400: '#FA9B0D',
    300: '#FBAE3B',
    200: '#FDD395',
    100: '#FEE6C3',
    50: '#FEF2E1',
  },

  success: {
    900: '#08150B',
    800: '#14361C',
    700: '#20562D',
    600: '#286C39',
    500: '#00854D',
    400: '#39BF54',
    300: '#58C172',
    200: '#B3E3BF',
    100: '#DAF2DF',
    50: '#F0F9F2',
  },

  tertiary: {
    900: '#3E314B',
    800: '#58466A',
    700: '#6C5681',
    600: '#7D6395',
    500: '#8B6FA7',
    400: '#9274AF',
    300: '#B6A6CB',
    200: '#DED7E5',
    100: '#EFE0F2',
    50: '#F6F5F8',
  },

  neutral: {
    900: '#0A0A0A',
    800: '#141414',
    700: '#232222',
    600: '#323131',
    500: '#3C3B3B',
    400: '#555353',
    300: '#6D6B6B',
    200: '#B6B5B5',
    100: '#D2D1D1',
    50: '#F3F3F3',
  },

  neutralVariant: {
    900: '#29292A',
    800: '#535354',
    700: '#67676A',
    600: '#919193',
    500: '#A6A6A8',
    400: '#B1B1B3',
    300: '#BCBCBE',
    200: '#D8D8D9',
    100: '#EAEAEA',
    50: '#F9F9FA',
  },
  specialColors: {
    white: '#FFFFFF',
    black: '#000000',
    bgVariant1: '#F4F4F4',
  },
};

export default colors;
